<template>
  <qx-card title="列表">
    <section slot="titleRight">
      <qx-permpisions permpisions="">
        <ExportBtn :len="tableData.data.length"
          queryUrl='accountBO.ajax?cmd=doAccountQueryDetails'
          :params="fullSearchData"
          bizName="车主账单明细导出"
          :excelKeys="excelKeys"
          :excelLables="excelLables"
          type="sync"
        />
      </qx-permpisions>
    </section>
    <section class="tablePage">
      <section class="tableBox">
        <el-table
          v-loading="tableData.loading"
          ref="multipleTable"
          :data="tableData.data"
          tooltip-effect="dark"
          @select="handleSelectionChange"
          @select-all="handleSelectionChange"
        >
          <el-table-column
            v-for="(item, index, key) in tableData.title"
            :key="key"
            :prop="item.prop"
            :label="item.label"
            :sortable="item.sortable"
            :filters="item.filters"
            :filter-method="item.filterHandler"
            :min-width="item.minW"
            :width="item.w"
            >
              <section  slot-scope="scope">
                <section v-if="scope.column.property === 'sourceRegionName'">
                  <span>{{scope.row.sourceRegionName}} - {{scope.row.desRegionName}}</span>
                </section>
                <section v-else>{{scope.row[scope.column.property]}}</section>
              </section>
            </el-table-column>
        </el-table>
      </section>
      <section class="paginationBox clearPa">
        <section class="right">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tableData.page"
            :page-sizes="[10, 20, 50]"
            :page-size="tableData.count"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tableData.total"
          ></el-pagination>
        </section>
      </section>
    </section>
  </qx-card>
</template>
<script>
import tableMixin from '@qx/mixin/table';
import ExportBtn from 'components/exportBtn';
import {
  driverExpireList,
} from 'api/getPay';
export default {
  mixins: [
    tableMixin,
  ],
  components: {
    ExportBtn,
  },
  data () {
    return {
      tableData: { // 表格相关数据
        loading: false,
        count: 10,
        page: 1,
        total: 0,
        selectResult: [], // 表格选中的结果
        title: [ // 表头
          {
            prop: 'orderId',
            label: '订单号',
          },
          {
            prop: 'sourceRegionName',
            label: '线路',
          },
          {
            prop: 'endDate',
            label: '回单时间',
          },
          {
            prop: 'noPayFinal',
            label: '未到期金额',
          },
          {
            prop: 'finalPianDate',
            label: '到期时间',
          },
          {
            prop: 'fianlStsName',
            label: '状态',
          },
        ],
        data: [ // 表格内容
        ],
      },
    };
  },
  methods: {
    getList: driverExpireList,
  },
};
</script>
<style lang="scss" scoped>
</style>
